import { Fragment, useCallback, useState } from "react";
import ShowroomsList from "../../../Showrooms/ShowroomsList";
import Button from "../../../UI/Button";
import Modal from "../../../UI/Modal";
import InputField from "../../../UI/Inputs/InputField";
import style from "./index.module.css";
import { addPhoneWhatsappHit, requestCallback } from "../../../../utils/fetcher";
import LoadingSkeleton from "../../../UI/LoadingSkeleton";
import { Phone, Profile, Whatsapp } from "../../../Icons";
import { CtasType } from "../VehicleSpecs";
import { useTranslation } from "../../../../hooks/useTranslation";
import { VehicleConditions, VehicleTypesT } from "../../../../utils/GeneralTypes";
import { convertToEnglishNumbers, rawPhoneNumber } from "../../../../utils/generalUtils";

const ContactUsedCar = ({
  name,
  phone,
  email,
  note,
  image,
  isUser,
  showroomID,
  isPreview = false,
  vehicleState,
  vehicleType: vehicleNames,
  vehicleID,
  ctas,
}: ComponentPropsType) => {
  const { locale } = useTranslation();
  const [isCallModalActive, setIsCallModalActive] = useState<boolean>(false);
  const [isCallBackModalActive, setIsCallBackModalActive] = useState<boolean>(false);

  const [callbackData, setCallbackData] = useState<{
    name: string;
    phone: string;
  }>({ name: "", phone: "" });
  const [callbackSubmission, setCallbackSubmission] = useState<{
    loading: boolean;
    success: string;
    error: string;
  }>({ loading: false, success: "", error: "" });

  const onCallbackVehicle = useCallback(async () => {
    if (showroomID) {
      setCallbackSubmission({
        loading: true,
        success: "",
        error: "",
      });
      let error = "",
        success = "";
      await requestCallback(
        +vehicleID,
        callbackData.name,
        "+20" + rawPhoneNumber(convertToEnglishNumbers(callbackData.phone)),
      )
        .then((res) => {
          success = res.data.message;
        })
        .catch((err) => {
          error = err.response.data.message;
        });
      setCallbackSubmission({
        loading: false,
        success,
        error,
      });

      if (success) {
        setIsCallModalActive(false);
        setIsCallBackModalActive(false);
      } else setIsCallBackModalActive(false);
    }
  }, [callbackData, showroomID, vehicleID]);

  const formatPhone = (phone: string) => {
    phone = phone.trim();
    return phone.length === 13 && phone.startsWith("+20") //+201111111111
      ? phone
      : phone.length === 12 && phone.startsWith("20") //201111111111
      ? "+" + phone
      : phone.length === 11 && phone.startsWith("0") //01111111111
      ? "+20" + phone.slice(1)
      : phone.length === 10 //1111111111
      ? "+20" + phone
      : phone;
  };

  return (
    <>
      {isCallBackModalActive && (
        <Modal
          onClose={() => {
            if (callbackSubmission.success) {
              setIsCallModalActive(false);
              setIsCallBackModalActive(false);
            } else setIsCallBackModalActive(false);
          }}
        >
          <div className={style.modal}>
            <p className={style.modal_title}>{locale("request_call_back")}</p>
            {!callbackSubmission.loading && (
              <>
                {callbackSubmission.error && (
                  <span
                    style={{
                      margin: "10px 0",
                      color: "red",
                      textAlign: "center",
                    }}
                  >
                    {callbackSubmission.error}
                  </span>
                )}
                {callbackSubmission.success && (
                  <span
                    style={{
                      margin: "10px 0",
                      color: "green",
                      textAlign: "center",
                    }}
                  >
                    {callbackSubmission.success}
                  </span>
                )}
              </>
            )}
            {callbackSubmission.loading ? (
              <div style={{ width: "100%", marginTop: "10px" }}>
                <LoadingSkeleton count={3} height="20px" />
              </div>
            ) : (
              <>
                <div className={style.modal_inputs}>
                  <InputField
                    type="text"
                    isSecondary={true}
                    label={locale("full_name")}
                    extraProps={{
                      name: "name",
                      value: callbackData.name,
                      onChange: (e: any) => {
                        setCallbackData((current) => ({
                          ...current,
                          [e.target.name]: e.target.value,
                        }));
                      },
                    }}
                  />
                  <InputField
                    type="phone"
                    isSecondary={true}
                    label={locale("mobile_number")}
                    note={locale("whatsapp_note")}
                    extraProps={{
                      name: "phone",
                      value: callbackData.phone,
                      onChange: (e: any) => {
                        setCallbackData((current) => ({
                          ...current,
                          [e.target.name]: e.target.value,
                        }));
                      },
                    }}
                  />
                </div>
                <div className={style.modal_ctas}>
                  <Button styleType="primary_black" buttonType="button" onClick={onCallbackVehicle}>
                    {locale("send")}
                  </Button>
                </div>
              </>
            )}
          </div>
        </Modal>
      )}
      {isCallModalActive && !isCallBackModalActive && (
        <Modal onClose={() => setIsCallModalActive(false)}>
          <div className={style.modal}>
            {!isUser ? (
              <ShowroomsList
                isSingle={true}
                showrooms={[
                  {
                    name,
                    image: image || "",
                    link: `/showrooms/showroom/${showroomID}`,
                  },
                ]}
              />
            ) : (
              <p className={style.modal_name}>{name}</p>
            )}
            {/* <p className={style.modal_phone}>{phone}</p> */}
            <div className={style.modal_ctas}>
              <a href={`tel:${formatPhone(phone)}`} target="_blank" rel="noreferrer" className={`mb-3`}>
                <Button styleType="primary" disabled={isPreview}>
                  <Phone width="20" height="20" color="#fff" />
                  <span className="mx-2">{formatPhone(phone)}</span>
                </Button>
              </a>
              {showroomID && (
                <Button styleType="primary_black" onClick={() => setIsCallBackModalActive(true)} disabled={isPreview}>
                  {locale("request_call_back")}
                </Button>
              )}
            </div>
          </div>
        </Modal>
      )}
      <div className={`${style.contact_section} row`}>
        <div className={`${style.showroom} col-sm-6`}>
          {(image || isUser) && (
            <div className={style.showroom_image} style={isUser ? { width: "60px", height: "60px" } : {}}>
              {isUser ? (
                <Profile width="30px" height="30px" color="#000" />
              ) : (
                <a href={`/showrooms/showroom/${showroomID}`}>
                  <img src={image} alt="" />
                </a>
              )}
            </div>
          )}
          <div className={style.showroom_details}>
            {isUser ? (
              <p>{name}</p>
            ) : (
              <a href={`/showrooms/showroom/${showroomID}`}>
                <p>{name}</p>
              </a>
            )}
            {note && <span>{note}</span>}
          </div>
        </div>
        <div className="col-sm-6">
          <div className={`${style.contact_ctas}`}>
            {ctas.map((cta, index) => (
              <Fragment key={index}>
                {cta.whatsapp && (
                  <a
                    href={`https://wa.me/${formatPhone(phone)}?lang=en`}
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => {
                      addPhoneWhatsappHit("whatsapp", vehicleNames, vehicleState, vehicleID);
                    }}
                  >
                    <Whatsapp width="50" height="50" color="#dc0000" />
                  </a>
                )}
                {cta.phone && (
                  <button
                    type="button"
                    className={style.contact_cta}
                    onClick={() => {
                      if (!isPreview) addPhoneWhatsappHit("phone", vehicleNames, vehicleState, vehicleID);
                      setIsCallModalActive(true);
                    }}
                  >
                    <Phone width="" height="25" color="#ffffff" />
                  </button>
                )}
              </Fragment>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUsedCar;

export type ContactType = {
  name: string;
  phone: string;
  email?: string | null;
  note?: string;
  image?: string;
  isUser?: boolean;
  showroomID?: number;
  isPreview?: boolean;
  vehicleState: VehicleConditions;
  vehicleType: VehicleTypesT;
  vehicleID: string | number;
  ctas: CtasType[];
};

interface ComponentPropsType extends ContactType {}
